export enum LoginView {
  LOGIN = 'login',
  VERIFY_AUTH_CODE = 'verifyAuthCode',
}
